module.exports = __webpack_public_path__ + "static/media/10.8ccd9f86.JPG";